import { render, staticRenderFns } from "./LastNotificationsPopup.vue?vue&type=template&id=4bd36cc0"
import script from "./LastNotificationsPopup.vue?vue&type=script&lang=js"
export * from "./LastNotificationsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports